import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import Card from 'components/Card/Card.jsx';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';

// @material-ui/icons
import Close from '@material-ui/icons/Close';
import loader from 'assets/img/loader.gif';
import CreateIcon from '@material-ui/icons/Create';



// style="height:30px;width:30px;background-color:black;position: relative;z-index: 999;float: right;bottom: 5px;margin-left: -80px;margin-top: 25%;border-radius: 50px;"



// core components
import GridContainer from 'components/Grid/GridContainer.jsx';
import Hidden from "@material-ui/core/Hidden";
import GridItem from 'components/Grid/GridItem.jsx';
import Button from 'components/CustomButtons/Button.jsx';
import ProfilePicUpload from 'components/CustomUpload/profilePicUpload';
import CardBody from 'components/Card/CardBody.jsx';
import CardHeader from 'components/Card/CardHeader.jsx';
import CardAvatar from 'components/Card/CardAvatar.jsx';
import SnackbarContent from 'components/Snackbar/SnackbarContent.jsx';
import Transition from 'components/Transition';
import Style from 'assets/jss/material-dashboard-pro-react/views/profileStyle';
import { capitalize } from '../../util';
// Forms
import ProfileForm from 'components/Forms/profileForm.jsx';

// Assets
import DefaultProfile from 'assets/img/default-avatar.png';

import server from 'services/ServerService';

import * as Actions from 'store/actions/profileActions';

class Profile extends React.Component {
  state = {
    updatePhotoModal: false,
    updateProfileModal: false,
  };

  render() {
    const { classes, user, photoURL, uid } = this.props;
    console.log('profile proppssss', this.props)
    const { firstName, lastName, userType } = user;

    let profilePhoto = user.avatar || photoURL || DefaultProfile;

    return (
      <GridContainer justify="center">
        <GridItem xs={11}>
          {uid ? (
            <GridContainer>
              <GridItem xs={12} sm={12} md={11}>
                <Card profile style={{ marginTop: '30px', paddingBottom: '20px' }}>
                  <div onClick={this.props.handleOpenPhotoDialog}>
                    <CardAvatar className={classes.avatarHover} profile>
                      <img
                        className={classes.profilePic}
                        src={profilePhoto}
                        alt="User Photo"
                      />
                    </CardAvatar>
                  </div>
                  <CardBody profile>
                    {/*<h6 className={classes.cardCategory}>CEO / CO-FOUNDER</h6>*/}
                    {firstName ? (
                      <h3 className={classes.body} style={{ marginTop: '-10px' }}>
                        {firstName} {lastName || null}
                      </h3>
                    ) : (
                        <div
                          style={{
                            padding: '0px 0px !important',
                            width: '100%',
                            marginTop: '-50px',
                          }}
                        >
                          <SnackbarContent
                            message={<b>Tap "Edit Profile" To Change Your City.</b>}
                            color="info"
                          />
                        </div>
                      )}
                    {userType ? (
                      <h5 className={classes.body}>{capitalize(userType)}</h5>
                    ) : (
                        <div
                          style={{
                            padding: '0px 0px !important',
                            width: '100%',
                            marginTop: '-50px',
                          }}
                        >
                          <SnackbarContent
                            message={
                              <b>Add More Information By Clicking "Edit Profile".</b>
                            }
                            color="info"
                          />
                        </div>
                      )}
                    {user.city ? (
                      user.city
                    ) : (
                        <div
                          style={{
                            padding: '0px 0px !important',
                            width: '100%',
                            marginTop: '-30px',
                            marginBottom: '-30px',
                          }}
                        >
                          <SnackbarContent
                            message={
                              <b>
                                Use The "Edit Profile" Button Below To Add A City...
                            </b>
                            }
                            color="info"
                          />
                        </div>
                      )}
                    , {user.state ? user.state : null}
                    {user.userType == 'client' ? null : (
                      <div className={classes.description}>
                        {user.barNumber ? (
                          'Bar #' + user.barNumber
                        ) : (
                            <div className={classes.body}>
                              Click UPDATE to add your Bar Number
                            </div>
                          )}{' '}
                        <br />
                        Experience Level:{' '}
                        <b>
                          {user.experience ? (
                            user.experience + ' years'
                          ) : (
                              <div
                                style={{
                                  padding: '0px 0px !important',
                                  width: '100%',
                                  marginTop: '-20px',
                                }}
                              >
                                <SnackbarContent
                                  message={
                                    <b>
                                      Tap "Edit Profile" To Update Your Experience.
                                  </b>
                                  }
                                  color="info"
                                />
                              </div>
                            )}
                        </b>
                      </div>
                    )}
                    {/*<Button color="rose" round>
                    Follow
                </Button>*/}
                  </CardBody>
                  <span style={{ padding: '0px 5%' }}>
                    <Button
                      style={{ width: '100%' }}
                      color="primary"
                      onClick={this.props.handleOpenEditDialog}
                    >
                      <b>EDIT PROFILE</b>
                    </Button>
                  </span>
                </Card>
                <Card>
                  <CardHeader>
                    <h4 className={classes.cardTitle}>Contact Information</h4>
                  </CardHeader>
                  <CardBody>
                    {/*<h6 className={classes.cardCategory}>CEO / CO-FOUNDER</h6>*/}
                    <div className={classes.description}>
                      <b>
                        {user.firmName ? (
                          user.firmName
                        ) : (
                            <div
                              style={{
                                padding: '0px 0px !important',
                                width: '100%',
                                marginTop: '-50px',
                                marginBottom: '-20px',
                              }}
                            >
                              <SnackbarContent
                                message={
                                  <b>
                                    Add More Information By Tapping "Edit Profile"
                                    above...
                                </b>
                                }
                                color="info"
                              />
                            </div>
                          )}
                      </b>
                      <br />
                      {user.currentPractice ? (
                        user.currentPractice) :
                        (
                          <div
                            style={{
                              padding: '0px 0px !important',
                              width: '100%',
                              marginTop: '-25px',
                              marginBottom: '-30px',
                            }}
                          >
                            <SnackbarContent
                              message={<b>You Don't Have A Firm Address On File Yet...</b>}
                              color="info"
                            />
                          </div>
                        )
                      }
                      <br />
                      {user.address ? (
                        user.address
                      ) : (
                          <div
                            style={{
                              padding: '0px 0px !important',
                              width: '100%',
                              marginTop: '-25px',
                              marginBottom: '-30px',
                            }}
                          >
                            <SnackbarContent
                              message={<b>You Don't Have An Address On File Yet...</b>}
                              color="info"
                            />
                          </div>
                        )}
                      <br />
                      {user.city || null} {user.state || null} {user.zip || null}
                    </div>
                    <div className={classes.description}>
                      {user.phone ? (
                        user.phone
                      ) : (
                          <div
                            style={{
                              padding: '0px 0px !important',
                              width: '100%',
                              marginTop: '-40px',
                            }}
                          >
                            <SnackbarContent
                              message={
                                <b>
                                  Tap "Edit Profile" To Update Your Phone Number...
                              </b>
                              }
                              color="info"
                            />
                          </div>
                        )}
                    </div>
                    <div className={classes.description}>
                      {user.email ? (
                        user.email
                      ) : (
                          <div
                            style={{
                              padding: '0px 0px !important',
                              width: '100%',
                              marginTop: '-50px',
                            }}
                          >
                            <SnackbarContent
                              message={
                                <b>Tap "Edit Profile" To Change Your Email...</b>
                              }
                              color="info"
                            />
                          </div>
                        )}
                    </div>

                    {/*<Button color="rose" round>
                    Follow
                </Button>*/}
                  </CardBody>
                </Card>
                <Card>
                  <CardHeader>
                    <h4 className={classes.cardTitle}>Profile</h4>
                  </CardHeader>
                  <CardBody>
                    {/*<h6 className={classes.cardCategory}>CEO / CO-FOUNDER</h6>*/}
                    <div className={classes.description}>
                      {user.bio ? (
                        user.bio
                      ) : (
                          <div
                            style={{
                              padding: '0px 0px !important',
                              width: '100%',
                              marginTop: '-50px',
                            }}
                          >
                            <SnackbarContent
                              message={
                                <b>
                                  You Don't Have A Bio Yet. Tap "Edit Profile" To Add
                                  One...
                              </b>
                              }
                              color="info"
                            />
                          </div>
                        )}
                    </div>

                    {/*<Button color="rose" round>
                  Follow
              </Button>*/}
                  </CardBody>
                </Card>

                {user.userType == 'lawyer' && (
                  <div>
                    <Card>
                      <CardHeader>
                        <h4 className={classes.cardTitle}>Availability</h4>
                      </CardHeader>
                      <CardBody>
                        {/*<h6 className={classes.cardCategory}>CEO / CO-FOUNDER</h6>*/}
                        <p className={classes.description}>Accepting new clients</p>
                        {/*<Button color="rose" round>
                                  Follow
                              </Button>*/}
                      </CardBody>
                    </Card>
                    {/* <Card paper>
                    <CardHeader paper>
                      <h4 className={classes.cardTitle}>Bar Memberships</h4>
                    </CardHeader>
                    <CardBody paper>

                    </CardBody>
                  </Card> */}
                  </div>
                )}
              </GridItem>

              {/* UPDATE PROFILE MODAL */}
              <Dialog
                classes={{
                  root: classes.modalRoot,
                  paper: classes.modal + ' ' + classes.modalLarge,
                }}
                open={this.props.editDialogOpen}
                TransitionComponent={Transition}
                keepMounted
                onClose={this.props.dialogClose}
                aria-labelledby="profile-edit-modal-title"
                aria-describedby="profile-edit-modal-description">
                {/* <DialogTitle
                  id="profile-edit-modal-title"
                  disableTypography
                  className={classes.modalHeader}>
                  <Button
                    simple
                    className={classes.modalCloseButton}
                    key="close"
                    aria-label="Close"
                    onClick={this.props.handleCloseEditDialog}>
                    {' '}
                    <Close className={classes.modalClose} />
                  </Button>
                </DialogTitle> */}
                <DialogContent
                  id="profile-edit-modal-description"
                  className={classes.modalBody}>
                  {/* MOBILE VIEW */}
                  <Button
                    className={classes.ltrButtonWhite}
                    style={{
                      backgroundColor: 'transparent',
                      color: 'black',
                      boxShadow: 'none',
                      position: 'relative',
                      zIndex: '9999',
                      fontSize: '20px',
                      float: 'right',
                    }}
                    key="close"
                    aria-label="Close"
                    onClick={this.props.handleCloseEditDialog}
                  >
                    X
                  </Button>

                  {/* FORM */}
                  {uid ? (
                    <ProfileForm
                      user={user}
                      uid={uid}
                      key={user.id}
                      modalOpen={this.props.editDialogOpen}
                      handleSubmit={this.props.handleSubmitEditDialog}
                    />
                  ) : null}
                  {/* MOBILE VIEW */}
                  <Button
                    className={classes.ltrButtonWhite}
                    style={{
                      backgroundColor: 'transparent',
                      color: 'black',
                      width: '100%',
                      boxShadow: 'none',
                      zIndex: '9999',
                      position: 'relative',
                      fontWeight: '600',
                      marginTop: "-50px"
                    }}
                    key="close"
                    aria-label="Close"
                    onClick={this.props.handleCloseEditDialog}
                  >
                    CLOSE
                  </Button>
                </DialogContent>
              </Dialog>

              {/* UPDATE PROFILE PHOTO MODAL */}
              <Dialog
                classes={{
                  root: classes.modalRoot,
                  paper: classes.modal + ' ' + classes.modalSmall,
                }}
                open={this.props.photoDialogOpen}
                TransitionComponent={Transition}
                keepMounted
                onClose={this.props.handleClosePhotoDialog}
                aria-labelledby="profile-photo-edit-modal-title"
                aria-describedby="profile-photo-edit-modal-description"
              >
                <Card
                  style={{
                    margin: '0px 0% 0px 5%',
                    width: '90%',
                    backgroundColor: '#F7F3F0',
                    borderRadius: '10px',
                  }}
                >
                  <DialogTitle
                    id="profile-photo-edit-modal-title"
                    disableTypography
                    className={classes.modalHeader}
                  >
                    {/* <Button
                      simple
                      className={classes.modalCloseButton}
                      key="close"
                      aria-label="Close"
                      onClick={this.props.handleClosePhotoDialog}
                    >
                      {' '}
                      <Close className={classes.modalClose} />
                    </Button> */}
                    <h2 className={classes.modalTitle}>
                      <span style={{ color: 'black' }}>
                        <center>Update Profile Photo</center>
                      </span>
                    </h2>
                  </DialogTitle>
                  <DialogContent
                    id="profile-photo-edit-modal-description"
                    className={classes.modalBody}
                  >
                    {/* FORM */}
                    {uid ? (
                      <ProfilePicUpload
                        currentPic={profilePhoto}
                        username={user.username}
                        uid={uid}
                        user={user}
                        key={user.id}
                        handleSubmit={this.props.handleSubmitPhotoDialog}
                      />
                    ) : null}
                    <div
                      style={{
                        textAlign: 'center',
                      }}
                    >
                      <Button
                        className={classes.ltrButtonWhite}
                        style={{ backgroundColor: '#FC6047', width: '90%' }}
                        key="close"
                        aria-label="Close"
                        onClick={this.props.handleClosePhotoDialog}
                      >
                        <b>CANCEL</b>
                      </Button>
                    </div>
                  </DialogContent>
                </Card>
              </Dialog>
              <div style={{ margin: '45px' }} />
            </GridContainer>
          ) : (
              <div
                style={{
                  backgroundColor: '#F7F4F0',
                  position: 'absolute',
                  width: '100%',
                  height: '100%',
                }}
              >
                <img
                  style={{
                    margin: '65% 0% 0% 38%',
                    position: 'relative',
                    width: '20%',
                  }}
                  src={loader}
                  alt="..."
                />
              </div>
            )}
        </GridItem>
      </GridContainer>
    );
  }
}

Profile.propTypes = {
  uid: PropTypes.string,
  classes: PropTypes.object.isRequired,
  photoURL: PropTypes.string,
  user: PropTypes.shape({}),
};

const mapStateToProps = ({ auth, user, profile }) => {
  const { uid } = auth.user || {};
  const { editDialogOpen, photoDialogOpen } = profile;
  return { uid, user: user.user, photoURL: user.user.profileURL, editDialogOpen, photoDialogOpen };
};

const mapDispatchToProps = dispatch => {
  return {
    handleSubmitEditDialog: (uid, data) => {
      server.updateUser(uid, data);
      dispatch(Actions.editDialogSave(data));
    },
    handleOpenEditDialog: () => {
      dispatch(Actions.editDialogOpen())
    },
    handleCloseEditDialog: () => {
      dispatch(Actions.editDialogClose())
    },
    handleSubmitPhotoDialog: (uid, uri) => {
      server.updateUser(uid, { profileURL: uri });
      dispatch(Actions.photoDialogSave(uri));
    },
    handleOpenPhotoDialog: () => {
      dispatch(Actions.photoDialogOpen())
    },
    handleClosePhotoDialog: () => {
      dispatch(Actions.photoDialogClose())
    }
  };
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(Style)
)(Profile);
